import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, ROLE_LEVELS } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("bcrp_token")) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("bcrp_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    localStorage.setItem("bcrp_token", data.token);
    await refresh();
    return data.user;
  };

  const register = async (username, email, password) => {
    const { data } = await api.post("/auth/register", { username, email, password });
    localStorage.setItem("bcrp_token", data.token);
    await refresh();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("bcrp_token");
    setUser(false);
  };

  const level = user ? (ROLE_LEVELS[user.role] ?? -1) : -1;

  return <AuthCtx.Provider value={{ user, login, register, logout, refresh, level }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
